import React from 'react';
import styled from 'styled-components';
import { Link } from '@99designs/emu';
import { FormattedReactMessage } from '@99designs/frontend-components/i18n';

const FormattedMessage = styled.p`
    white-space: pre-line;
`;

export function formatSubtext(
    subtext: string | null,
    subtextLink: string | null
): string | JSX.Element {
    if (!subtext) {
        return '';
    }

    if (subtextLink) {
        return (
            <FormattedMessage>
                <FormattedReactMessage
                    message={subtext}
                    replacements={{
                        Link: <Link href={subtextLink} />,
                    }}
                />
            </FormattedMessage>
        );
    }

    return subtext;
}
